export const getFormatCurrencyValue = (value: any) => {
  if (value === "" || isNaN(Number(value))) {
    return value;
  }
  return new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(
    Number(value)
  );
};
